import React, { Component } from 'react';
import { TextInput } from '../shared/TextInput'
import Select from 'react-select';
import _ from 'lodash'

export default class KegmeisterFees extends Component {
  render() {
    return (
      <div>
        <label>
          Kegmeister Fees
        </label>
        <Select
          className='km-fees'
          clearable={ false }
          name="form-field-name"
          style={
            {
              'color': '#333',
              'backgroundColor': '#F9F9F9',
              'outline': 'none',
              'borderColor':'none',
              'width': 315,
              'height': 40
            }
          }
          optionClassName='km-select'
          value={ this.props.passOn ? 'pass_on' : 'absorb' }
          onChange={ this.props.handleFeeChange }
          options={ [
            { value: 'pass_on', label: 'Pass Fees On' },
            { value: 'absorb', label: 'Absorb Fees' }
          ] }
        />
        <div>
          <label style={{ fontSize: '12px'}}>
            {
              this.props.passOn
                ? 'The buyer will pay the 6.5% Kegmeisters service fee'
                : 'The brewery will pay the 6.5% Kegmeisters service fee'
            }
          </label>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Settings/KegmeisterFees.jsx